<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de movimentação de psicotrópico">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/farmacia/relatorio-movimentacao-psicotropico/List'

export default {
    components: { List },
}
</script>